import type { Reply } from 'models';
import type { ComponentProps } from 'react';
import type { RichTextMentions } from 'ui';
import { CommentForm, type CommentFormValues } from '../comment-form';
import { useEditCommentMutation } from '../queries';

const initFormValues = (reply: Reply): ComponentProps<typeof CommentForm>['initialValues'] => ({
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  attachments: { files: reply.attachments ?? [], loading: false },
  htmlContent: reply.htmlContent,
  textContent: reply.textContent,
});

type P = {
  comment: Reply;
  contentObjectId: string;
  onRequestMentions: RichTextMentions;
  onSuccess: () => void;
};

const EditCommentForm = ({ comment, contentObjectId, onRequestMentions, onSuccess }: P) => {
  const { isPending: isEditingComment, mutate: editComent } = useEditCommentMutation();

  const onFinish = (values: CommentFormValues) => {
    editComent(
      {
        attachments: values.attachments.files,
        contentObjectId,
        htmlContent: values.htmlContent,
        id: comment.id,
        parentId: comment.parentId,
        textContent: values.textContent,
      },
      {
        onSuccess() {
          onSuccess();
        },
      },
    );
  };

  return (
    <CommentForm
      avatar={false}
      initialValues={initFormValues(comment)}
      isLoading={isEditingComment}
      onRequestMentions={onRequestMentions}
      onSubmit={onFinish}
    />
  );
};

export default EditCommentForm;
